/* Page Maker navigation. Every destination ID belongs to one section instance.
 * Repeated aliases resolve within the link's section first, then to the next
 * destination in document order, then to the final preceding destination.
 * Both layout families share one controller, including Theme Editor updates. */
(function () {
  'use strict';
  if (window.__spmReusableAnchors) return;
  window.__spmReusableAnchors = true;
  var rootSelector = '[data-spm-reuse]';
  var targetSelector = '[data-spm-anchor-target]';
  var linkState = new WeakMap();
  var editor = !!(window.Shopify && window.Shopify.designMode);

  function alive(element) {
    return !element.closest('[data-spm-unloaded]');
  }
  function aliasValue(value) {
    return (value || '').replace(/^#/, '').trim();
  }
  function targets() {
    return Array.prototype.filter.call(document.querySelectorAll(targetSelector), function (target) {
      // Hidden or unloaded Theme Editor sections can remain in the DOM.
      return alive(target) && !target.closest('[hidden]') && (!target.getClientRects || target.getClientRects().length > 0);
    });
  }
  function resolve(alias, candidates, source) {
    if (!/^[A-Za-z0-9][A-Za-z0-9-]*$/.test(alias)) return { target: null, reason: 'invalid' };
    var matches = candidates.filter(function (target) {
      return aliasValue(target.getAttribute('data-spm-anchor-target')) === alias;
    });
    if (!matches.length) return { target: null, reason: 'missing' };
    var target;
    if (source) {
      var ownSection = source.closest(rootSelector);
      target = matches.find(function (match) { return match.closest(rootSelector) === ownSection; });
      if (!target) target = matches.find(function (match) { return !!(source.compareDocumentPosition(match) & 4); });
    }
    // An initial alias hash has no source link, so it opens the first match.
    if (!target) target = source ? matches[matches.length - 1] : matches[0];
    return { target: target, reason: matches.length > 1 ? 'duplicate' : null };
  }
  function message(alias, reason) {
    if (reason === 'duplicate') return 'Anchor alias "' + alias + '" is used by multiple sections. Links use their own section, otherwise the next destination, otherwise the last preceding destination. Set distinct Anchor aliases and link targets to choose explicitly.';
    if (reason === 'invalid') return 'Anchor alias "' + alias + '" is invalid. Use letters, numbers and hyphens. This link is hidden on the storefront.';
    return 'Anchor target "' + alias + '" is missing or hidden. Add or show the destination section, or update this link target. This link is hidden on the storefront.';
  }
  function attribute(element, name, value) {
    if (value === null) { if (element.getAttribute(name) !== null) element.removeAttribute(name); }
    else if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }
  function updateLink(link, candidates) {
    var state = linkState.get(link);
    if (!state) {
      state = { hidden: link.hidden, role: link.getAttribute('role'), tabindex: link.getAttribute('tabindex'), disabled: link.getAttribute('aria-disabled') };
      linkState.set(link, state);
    }
    var alias = link.getAttribute('data-spm-anchor-alias');
    if (alias === null) {
      alias = aliasValue(link.getAttribute('href'));
      link.setAttribute('data-spm-anchor-alias', alias);
    }
    var purchaseLink = link.getAttribute('data-spm-purchase-link') !== null;
    if (purchaseLink) candidates = candidates.filter(function (target) {
      return target.getAttribute('data-spm-purchase-target') !== null && !!target.getAttribute('data-spm-product-url');
    });
    var resolution = resolve(alias, candidates, link);
    var productUrl = purchaseLink && resolution.target && resolution.target.getAttribute('data-spm-product-url');
    if (resolution.target) {
      // Storefront links retain the actual destination product. The editor must
      // keep a local href so Shopify does not intercept the purchase request.
      attribute(link, 'href', productUrl && !editor ? productUrl : '#' + resolution.target.id);
      attribute(link, 'aria-disabled', state.disabled);
      attribute(link, 'role', state.role);
      attribute(link, 'tabindex', state.tabindex);
      if (link.hidden !== state.hidden) link.hidden = state.hidden;
    } else {
      attribute(link, 'href', null);
      attribute(link, 'aria-disabled', 'true');
      attribute(link, 'role', 'link');
      attribute(link, 'tabindex', editor ? '0' : '-1');
      var hidden = state.hidden || !editor;
      if (link.hidden !== hidden) link.hidden = hidden;
    }
    return { alias: alias, target: resolution.target, reason: resolution.reason, productUrl: productUrl };
  }
  function refresh() {
    var candidates = targets();
    var roots = Array.prototype.filter.call(document.querySelectorAll(rootSelector), alive);
    roots.forEach(function (root) {
      var warnings = [];
      root.querySelectorAll(targetSelector).forEach(function (target) {
        var alias = aliasValue(target.getAttribute('data-spm-anchor-target'));
        if (!alias) return; // Empty aliases opt out of navigation.
        var resolution = resolve(alias, candidates, target);
        if (resolution.reason) warnings.push(message(alias, resolution.reason));
      });
      root.querySelectorAll('[data-spm-anchor]').forEach(function (link) {
        var resolution = updateLink(link, candidates);
        if (resolution.reason) warnings.push(message(resolution.alias, resolution.reason));
      });
      var notice = root.querySelector('[data-spm-anchor-notice]');
      if (notice) {
        var text = warnings.filter(function (value, index, all) { return all.indexOf(value) === index; }).join(' ');
        if (notice.textContent !== text) notice.textContent = text;
        var hidden = !editor || !warnings.length;
        if (notice.hidden !== hidden) notice.hidden = hidden;
      }
    });
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-spm-anchor]');
    if (!link || !link.closest(rootSelector) || event.defaultPrevented) return;
    // Ordinary anchors stay native. Purchase CTAs request the primary form;
    // unhandled requests and modified clicks retain the actual product URL.
    var resolution = updateLink(link, targets());
    if (!resolution.target) { event.preventDefault(); refresh(); }
    else if (resolution.productUrl && !event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey &&
             (!event.button || event.button === 0) && !link.getAttribute('target') && link.getAttribute('download') === null) {
      // The primary purchase module precedes companion cards in each target.
      var commerce = resolution.target.querySelector('[data-spm-commerce]');
      if (commerce) {
        var request = new CustomEvent('spm:purchase-request', { cancelable: true, detail: { trigger: link } });
        commerce.dispatchEvent(request);
        if (request.defaultPrevented) event.preventDefault();
      }
    }
  });
  function lifecycle(event) {
    if (event.type === 'shopify:section:unload') event.target.setAttribute('data-spm-unloaded', 'true');
    if (event.type === 'shopify:section:load') event.target.removeAttribute('data-spm-unloaded');
    refresh();
    if (window.requestAnimationFrame) window.requestAnimationFrame(refresh);
  }
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder', 'shopify:section:select', 'shopify:section:deselect'].forEach(function (name) {
    document.addEventListener(name, lifecycle);
  });
  function initial() {
    refresh();
    var hash = aliasValue(window.location && window.location.hash);
    if (hash) {
      var resolution = resolve(hash, targets());
      if (resolution.target) resolution.target.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
    if (window.MutationObserver && document.documentElement) {
      var scheduled = false;
      new window.MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () { scheduled = false; refresh(); });
      }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'style', 'class', 'data-spm-anchor-target', 'data-spm-product-url', 'data-spm-unloaded'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initial, { once: true });
  else initial();
}());
